module.exports = __webpack_public_path__ + "static/pool-removal-3a9c03c201212ff316ec243ae31688c1.jpg";